
<script>
export default {
  name: "artist-page",
  created() {
    console.log("Created")
  }
}
</script>

<style scoped>

</style>